import { computed } from 'vue';
import MailBoxRow from '@/src/components/MailBoxRow.vue';

export function useSmtpReconnect(editingMailboxId, isModalVisible) {
  const handleReconnectSmtp = (emailData) => {
    editingMailboxId.value = emailData.id;
    isModalVisible.value = true;
  };

  const customColumnRenderWithProps = computed(() => ({
    email: {
      component: MailBoxRow,
      props: (row) => ({
        value: row.email,
        row: row,
      }),
      listeners: {
        reconnectSmtp: handleReconnectSmtp,
      },
    },
  }));

  return {
    handleReconnectSmtp,
    customColumnRenderWithProps,
  };
}